export const isLoggedIn = () =>
  fetch(process.env.REACT_APP_LOGIN_VERIFY_API, { credentials: 'include' });

export const getUserInfo = () =>
  new Promise((resolve, reject) => {
    fetch(process.env.REACT_APP_USER_INFO_API, { credentials: 'include' })
      .then((response) => response.json())
      .then((json) => {
        resolve(json);
      })
      .catch((res) => {
        reject(res);
      });
  });

const isObject = (object) => object != null && typeof object === 'object';
const isArray = (array) => Array.isArray(array);

const encodeParam = (key, value) => {
  if (isObject(value) && !isArray(value)) {
    return `${encodeURIComponent(key)}=${encodeURIComponent(JSON.stringify(value))}`;
  }
  if (isArray(value)) {
    return value
      .map((current) => `${encodeURIComponent(key)}=${encodeURIComponent(current)}`)
      .join('&');
  }
  return `${encodeURIComponent(key)}=${encodeURIComponent(value)}`;
};

const searchParams = (params) =>
  Object.keys(params)
    .map((key) => encodeParam(key, params[key]))
    .join('&');

export const submitInquiries = (payload) =>
  fetch(process.env.REACT_APP_INQUIRIES_URL, {
    headers: {
      accept:
        'text/html,application/xhtml+xml,application/xml;q=0.9,image/avif,image/webp,image/apng,*/*;q=0.8,application/signed-exchange;v=b3;q=0.9',
      'content-type': 'application/x-www-form-urlencoded',
      'Access-Control-Allow-Origin': '*',
      'Access-Control-Allow-Headers': 'X-Requested-With',
    },
    method: 'POST',
    mode: 'no-cors',
    credentials: 'omit',
    body: searchParams(payload),
  });

export const getSubscriptionPrices = () =>
  new Promise((resolve, reject) => {
    fetch(`${process.env.REACT_APP_LOCALIZATION_API}/api/1/subscription/plans`)
      .then((res) => res.json())
      .then((json) => resolve(json))
      .catch((res) => reject(res));
  });
